import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import DataComponent from '../../../DataComponent/DataComponent';
import moment from 'moment';
import UserStore from '../../../../stores/UserStore';

const CurrencyRatioPageContainer = ({
    headerNames,
    currencyRatios,
    totalPages,
    loading,
    currency,
    allCurrencyRatios,
    onChangeData,
    getCurrencyRatios,
    getCurrenciesList,
    selectOptions,
    t
}) => {
    const [state, setState] = useState({
        headerNames: headerNames,
        currencyRatios: currencyRatios,
        totalPages: totalPages,
        loading: loading,
        currency: currency,
        allCurrencyRatios: allCurrencyRatios,
        page: 1
    });

    const staticNames = (t && t.dataTable) || {};
    const timezone = UserStore.getTimeZone();
    const staticNameCurrencyRatios = (t && t.exchangeRates && t.exchangeRates.title) || '';

    const onChangeDataHandler = useCallback(() => {
        onChangeData(state, (data) => {
            setState(prevState => ({
                ...prevState,
                ...data
            }));
        });
    }, [state, onChangeData]);

    useEffect(() => {
        const isChangeData = (state.loading && !loading) || state.currencyRatios.length > 0;

        setState(prevState => ({
            ...prevState,
            totalPages: totalPages,
            loading: loading
        }));

        if (isChangeData) {
            onChangeDataHandler();
        }
    }, [totalPages, loading, onChangeDataHandler]);

    const onDataTableAction = useCallback((actionState, actionType) => {
        const isChangeData = actionType === 'selectChange' && state.page === 1;

        setState(prevState => ({
            ...prevState,
            page: actionState.page,
            currency: actionState.currency || prevState.currency
        }));

        if (isChangeData) {
            onChangeDataHandler();
        } else {
            getCurrencyRatios(actionState);
        }
    }, [state.page, state.currency, onChangeDataHandler, getCurrencyRatios]);

    const toDay = useMemo(() => moment().tz(timezone), [timezone]);

    const fields = useMemo(() => [
        {
            name: 'datepicker',
            key: 'create',
            label: staticNames.headers?.createdAt,
            dropdownLabel: staticNames.filter,
            disabled: true,
            withList: true,
            list: [
                {title: staticNames.rangeNames?.today, value: { startDate: toDay, endDate: toDay}},
                {title: staticNames.rangeNames?.yesterday, value: { startDate: toDay.clone().subtract(1, 'day'), endDate: toDay.clone().subtract(1, 'day')} },
                {title: staticNames.rangeNames?.week, value: { startDate: toDay.clone().subtract(1, 'week'), endDate: toDay} },
                {title: staticNames.rangeNames?.month, value: { startDate:toDay.clone().subtract(1, 'months'), endDate: toDay} },
                {title: staticNames.rangeNames?.year, value: { startDate: toDay.clone().subtract(1, 'year'), endDate: toDay} }
            ]
        },
        {
            key: 'currency',
            data: selectOptions,
            label: staticNames.headers?.filterByCurrency,
            disabled: true,
            value: state.currency,
            withoutDropdown: true,
            withList: true,
            showSubtitle: true,
            list: selectOptions.length > 0 ? selectOptions : [{title: state.currency, value: state.currency}]
        }
    ], [staticNames, toDay, selectOptions, state.currency]);

    return (
        <DataComponent
            onAction={onDataTableAction}
            totalPages={state.totalPages}
            multiLevelHeaderNames={state.headerNames}
            page={state.page}
            data={state.currencyRatios}
            loading={state.loading}
            isQuery={true}
            hideResetButton={true}
            currencySettings={true}
            currencySettingData={getCurrenciesList()}
            currencySettingKey={'currencies'}
            currencySettingAction={onDataTableAction}
            tableBodyTitle={staticNameCurrencyRatios}
            className="simple-table double-row-header green-hover"
            gray={true}
            fields={fields}
        />
    );
};

CurrencyRatioPageContainer.propTypes = {
    currencyRatios: PropTypes.array,
    headerNames: PropTypes.array,
    totalPages: PropTypes.number,
    loading: PropTypes.bool,
    currency: PropTypes.string,
    allCurrencyRatios: PropTypes.array,
    onChangeData: PropTypes.func,
    getCurrencyRatios: PropTypes.func,
    getCurrenciesList: PropTypes.func,
    selectOptions: PropTypes.array,
    t: PropTypes.object
};

CurrencyRatioPageContainer.defaultProps = {
    currencyRatios: [],
    headerNames: [],
    totalPages: 0,
    loading: false,
    currency: '',
    allCurrencyRatios: [],
    onChangeData: () => {},
    getCurrencyRatios: () => {},
    getCurrenciesList: () => [],
    selectOptions: []
};

export default withTranslation(CurrencyRatioPageContainer);
